import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Icon from 'wonderbly-components/lib/Icon';
import RichText from '../Prismic/RichText';
import { prismicImage } from 'src/common/utils/prismic-image';
import './ValuePropsII.scss';
const has = require('lodash/has');

const ValuePropsII = props => (
  <section className="value-props-ii">
    <div className="container-guttered">
      <div className="value-props-ii-row">
        {props.items.map((item, idx) => (
          <div className="value-prop-ii" key={idx}>
            {!has(item, 'image.url') ?               
              <div className="value-prop-ii-shape" style={{ color: item.icon.color, backgroundColor: item.icon.backgroundColor }}>
                <Icon icon={(item.icon.name)}/>
              </div> :
              <div className="value-prop-ii-shape">
                <LazyLoad>
                  <img className="value-prop-ii-image" src={prismicImage(item.image)} alt={item.image.alt || ''} />
                </LazyLoad>
              </div>}
            <div className="value-prop-ii-content">
              <h4 className="text-base">{item.title}</h4>
              <RichText fields={item.description} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

ValuePropsII.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.array.isRequired,
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        backgroundColor: PropTypes.string.isRequired,
      }),
    ]),
    image: PropTypes.object
  })).isRequired
};

export default ValuePropsII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ValuePropsII/ValuePropsII.js